<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="animate-pulse rounded-sm bg-gray-200"></div>
</template>
